import React, { useEffect, useState } from "react";
export interface Props {title : string, name : string, fileUrl : string, fileName : string, setData : Function}
export const AttachedFileBox:React.FC<Props> = ({title,name,fileName,fileUrl,setData}) => {
    const [file, setFile] = useState<string>('')
    const handleChange = (e:any) => {
        const {name} = e.target;
        const reader = new FileReader();
        if(e.target.files[0]){reader.readAsDataURL(e.target.files[0])}
        reader.onload=()=>{
            setData((prev:any)=>({...prev, [name] : e.target.files[0]}));
            setFile(e.target.files[0].name)
        }
    }
    const handleDelFile= () => {setData((prev:any) => ({...prev, [name] : ''}));setFile('')}
    const handleDownLoad = () => {
        const files: any = fileUrl;
        const filePath = files.substring(files.lastIndexOf('/') + 1);
        const downLoad = document.createElement('a');
        downLoad.download = filePath;
        downLoad.href = files;
        downLoad.target = "_blank";
        document.body.appendChild(downLoad);
        downLoad.click();
        document.body.removeChild(downLoad);
    }
    useEffect(()=>{
        if(fileName !== ''){setFile(fileName)}
    }, [fileName])
    return(
        <>
        <tr>
            <th className="thumbnail">{title}</th>
            <td>
                {file === '' || file === undefined ? 
                <div className="imgUploadBox imgUploadBox_before">
                    <input type="file" onChange={handleChange} name={name} id={name}/>
                    <label htmlFor={name} className="imgUploadBtn imgUploadBtn_before">
                        <i className="fa-light fa-upload"></i>
                        카탈로그 업로드
                    </label>
                </div>:
                <div className="imgUploadBox imgUploadBox_after">
                    <span className="uploadFileName" onClick={handleDelFile}>
                        <button></button>
                        <div onClick={handleDownLoad}>{file}</div>
                    </span>
                </div>
                }
            </td>
        </tr>
        </>
    )
}